import { Descriptions, Modal } from 'antd'
import TextArea from 'antd/lib/input/TextArea'
import React from 'react'
import { withTranslation } from 'react-i18next'
import { StatusComponent } from '../../../common/component/Index'

const { Item } = Descriptions

const UpdateStatus = (props) => {
    const {
        data,
        handleOk,
        handleCancel,
        onChangeNote,
        note,
        t
    } = props

    return (
        <Modal
            title={t(`item.promotions.title${data.isActive ? 'DeActive' : 'Active' }`)}
            width={1000}
            visible={!!data}
            onOk={handleOk}
            onCancel={handleCancel}
            okText={t(`item.promotions.${data.isActive ? 'deactive' : 'active'}`)}
            >
                <Descriptions bordered title={t('item.promotions.promotionInfo')} bordered column={2} size='middle' className="m-b">
                    <Item label={t('item.promotions.campaignName')} >{data.campaignName}</Item>
                    <Item label={t('item.promotions.bundleName')}>{data.bundleName}</Item>
                    <Item label={t('item.promotions.promotionCode')}>{data.promotionCode}</Item>
                    <Item label={t('item.promotions.currentStatus')}>
                        <StatusComponent color={data.isActive ? 'green' : 'red'}
                            label={data.isActive ? t('item.promotions.active') : t('item.promotions.deactive')} />
                    </Item>
                </Descriptions>
                <p>{t('item.promotions.note')}: </p>
                <TextArea rows={3} value={note} onChange={(e) => onChangeNote(e.target.value)}/>
        </Modal>
    )
}

export default withTranslation()(UpdateStatus)